/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { get } from 'utils/lodash'

const initialState = {
  sortModel: [],
}

const persistentCustomerDetailsLocationsSlice = createSlice({
  name: 'persistentCustomerDetailsLocations',
  initialState: { ...initialState },
  reducers: {
    setSortModel: (state, action) => {
      state.sortModel = action.payload
    },
    resetState: () => initialState,
  },
})

export const { setSortModel, resetState } = persistentCustomerDetailsLocationsSlice.actions

export const selectSortModel = state => get(state, 'persistentCustomerDetailsLocations.sortModel', [])

export default persistentCustomerDetailsLocationsSlice.reducer
